module.exports = __webpack_public_path__ + "static/rates-logo-cd556ab39a12e402e146e262101c2d81.png";